{
  "{0} Invitation(s) successfully sent": "{0} 件の招待状が正常に送信されました",
  "{0} properties added to the brand": "ブランドに{0}プロパティが追加されました",
  "{0} properties added to the cluster": "クラスターに{0}個のプロパティが追加されました",
  "{0} properties added to user": "ユーザーに{0}プロパティが追加されました",
  "{assigned} of {total} User assigned | {assigned} of {total} Users assigned": "{total}ユーザー中{assigned}ユーザーが割り当て済み | {total}ユーザー中{assigned}ユーザーが割り当て済み",
  "{count} properties": "{count} プロパティ",
  "{count} weren't updated": "{count} は更新されませんでした",
  "{num} user(s) assigned to the property": "その物件に割り当てられたユーザー数",
  "{num} user(s) assigned to the site": "サイトに割り当てられたユーザー数",
  "1 wasn't updated": "1は更新されませんでした",
  "A cluster or brand with this name already exists. Please, choose another one.": "この名前のクラスターまたはブランドはすでに存在します。別のものを選んでください。",
  "A page with this name already exists. Please, choose another one.": "この名前のページはすでに存在します。別の名前を選んでください。",
  "A report will be sent by email every first week of the month summarizing the previous months data.": "前月のデータをまとめたレポートが毎月第1週にEメールで送信されます。",
  "A report will be sent by email every week summarizing the previous weeks data.": "前週のデータをまとめたレポートが毎週Eメールで送信されます。",
  "A report will be sent by email summarizing the previous days data.": "前日のデータをまとめたレポートがEメールで送信されます。",
  "Access to data analytics on the Personalization Dashboard and BenchDirect for specific properties of the account": "アカウントの特定のプロパティに関するパーソナライゼーションダッシュボードおよびBenchDirectでのデータ分析へのアクセス",
  "Access to operate in all products for specific properties of the account, without permission to edit settings": "アカウントの特定のプロパティについて、設定を編集する許可なしにすべての製品で操作するアクセス権",
  "Account": "アカウント",
  "Account information": "アカウント情報",
  "Account settings": "アカウント設定",
  "Account users": "アカウントユーザー",
  "Account was successfully updated.": "アカウントは正常に更新されました。",
  "Action required: Please {link} to continue.": "対応が必要です：続行するには{リンク}をクリックしてください。",
  "Activated": "アクティベートされた",
  "Add": "追加",
  "Add another set of rules": "別のルールを追加する",
  "Add JavaScript condition": "JavaScriptの条件を追加する",
  "Add new notification": "新しい通知を追加する",
  "Add page": "ページを追加する",
  "Add properties": "プロパティの追加",
  "Add properties to this brand": "このブランドにプロパティを追加する",
  "Add properties to this cluster": "このクラスターにプロパティを追加する",
  "Add the email(s) of the user(s) you want to invite:": "招待したいユーザーのメールアドレスを追加してください:",
  "Add user(s) email...": "ユーザーのメールアドレスを追加...",
  "added": "追加された",
  "Admin": "管理者",
  "Adults Only": "大人限定",
  "Airport Hotel": "空港ホテル",
  "All": "すべて",
  "All data changes will be updated after 24hrs, so don’t worry if you don’t see your changes applied immediatly.": "すべてのデータ変更は24時間後に更新されますので、すぐに変更が適用されていない場合でもご心配なく。",
  "All properties": "全物件",
  "All properties from all my accounts.": "すべての口座からのすべてのプロパティ。",
  "All properties from this account selected.": "このアカウントからのすべてのプロパティが選択されました。",
  "All properties from this account.": "このアカウントのすべてのプロパティ。",
  "All properties from your accounts selected.": "アカウントから選択されたすべてのプロパティ。",
  "All rules apply": "すべてのルールが適用されます",
  "All the properties were updated successfully.": "すべてのプロパティは正常に更新されました。",
  "All the sites were updated successfully.": "すべてのサイトは正常に更新されました。",
  "All your properties have already been assigned to a brand group. Transfer properties from other brands if you want to populate a new brand group": "すべてのプロパティはすでにブランドグループに割り当てられています。新しいブランドグループを構成したい場合は、他のブランドからプロパティを移行してください。",
  "All your team members have access to this property.": "あなたのチームメンバー全員がこの物件にアクセスできます。",
  "All your team members have access to this site.": "あなたのチームメンバー全員がこのサイトにアクセスできます。",
  "An error occurred while sending the email. Please try again later.": "メールを送信中にエラーが発生しました。後でもう一度お試しください。",
  "An error occurred. Please try again": "エラーが発生しました。もう一度お試しください",
  "analyst": "アナリスト",
  "Analyst": "アナリスト",
  "Any rule applies": "何らかのルールが適用されます",
  "Aparthotel": "アパートホテル",
  "Are you sure you want to delete this brand?": "このブランドを削除してもよろしいですか？",
  "Are you sure you want to delete this cluster?": "このクラスターを削除してもよろしいですか？",
  "Are you sure you want to proceed?": "続行しますか？",
  "Are you sure you want to remove the access?": "アクセスを削除してもよろしいですか？",
  "Are you sure you want to remove this property from this brand?": "このプロパティをこのブランドから削除してもよろしいですか？",
  "Are you sure you want to remove this property from this cluster?": "このプロパティをこのクラスターから削除してもよろしいですか？",
  "Are you sure you want to remove this user from this account?": "このユーザーをこのアカウントから削除してもよろしいですか？",
  "Ask Ernest": "アーネストに尋ねてください",
  "Available languages": "利用可能な言語",
  "Back": "戻る",
  "Back to Pages": "ページに戻る",
  "Beach": "ビーチ",
  "BenchDirect": "ベンチダイレクト",
  "Benchdirect": "ベンチダイレクト",
  "Benchmark the key metrics of your direct booking channel": "直接予約チャネルの主要な指標をベンチマークする",
  "Benchmark the key metrics of your direct channel": "直接チャネルの主要な指標をベンチマークする",
  "Book multiplier": "ブック乗数",
  "Book Multiplier": "ブックマルチプライヤー",
  "Booking Engine Pages": "予約エンジンページ",
  "Booking Engine pages include {pageExamples} and others. Your Booking Engine pages can't be edited. If you encounter any issues on these pages, please contact our Support team via chat.": "予約エンジンページには{pageExamples}などがあります。予約エンジンページは編集できません。これらのページで問題が発生した場合は、チャット経由でサポートチームにご連絡ください。",
  "Boutique": "ブティック",
  "Brand": "ブランド",
  "Brand information": "ブランド情報",
  "Brand name": "ブランド名",
  "Brands": "ブランド",
  "Brands allow you to group your properties however you may need.": "ブランドを使用すると、必要に応じてプロパティをグループ化できます。",
  "Brands without any properties will be deleted after 30 days of inactivity": "プロパティのないブランドは、30日間の非アクティブ状態の後、削除されます",
  "Business": "出張",
  "Can’t access 1Password?": "1Passwordにアクセスできませんか？",
  "Cancel": "キャンセル",
  "Casino": "カジノ",
  "Category (Stars)": "カテゴリー（星）",
  "Change password": "パスワードを変更する",
  "Change the user role to adjust permissions": "ユーザーの役割を変更して権限を調整する",
  "Change your password": "パスワードを変更する",
  "Check the items that you want to copy.": "コピーしたい項目を確認してください。",
  "Choose a beautiful picture of your hotel. This landing photo is used in multiple tools, whenever THN creates a page/email for the hotel. For example, in the Saved Searches email.": "ホテルの美しい写真を一枚選んでください。このランディング写真は、THNがホテルに関するページやメールを作成する際に複数のツールで使用されます。例えば、「保存済み検索」のメールなどです。",
  "Choose a beautiful picture of your site. This landing photo is used in multiple tools, whenever THN creates a page/email for the site. For example, in the Saved Searches email.": "サイトの美しい写真を1枚選んでください。このランディング写真は、THNがサイトのページやメールを作成する際に複数のツールで使用されます。例えば、「保存済み検索」のメールなどです。",
  "Choose a product to start": "始める製品を選んでください",
  "Choose file": "ファイルを選択",
  "Choose for which properties you'll upload URLs": "どのプロパティにURLをアップロードするか選択してください",
  "Choose languages": "言語を選択してください",
  "City": "都市",
  "Cluster Information": "クラスター情報",
  "Cluster name": "クラスター名",
  "Clusters": "クラスター",
  "Clusters allow you to group your hotels with the same cluster.": "クラスターを使用すると、同じクラスターのホテルをグループ化できます。",
  "Clusters allow you to group your properties however you may need.": "クラスターを使用すると、必要に応じてプロパティをグループ化できます。",
  "Color": "カラー",
  "Conference": "会議",
  "Configure the communications that you want to receive from us through the link below. Apart from this configuration, you will receive relevant product news that may affect you.": "以下のリンクから、当社から受け取りたい連絡先を設定してください。この設定とは別に、お客様に影響を与える可能性のある関連製品ニュースが届く場合があります。",
  "Confirm": "確認",
  "Confirm new password": "新しいパスワードを確認してください",
  "Confirm password": "パスワードの確認",
  "Content": "内容",
  "Conversion": "変換",
  "Convince your visitors to book directly on your website": "お客様にウェブサイトで直接予約していただくようお勧めください",
  "Copied": "コピーしました",
  "Copied settings will be assigned to the selected properties:": "コピーされた設定が選択されたプロパティに割り当てられます。",
  "Copied settings will be assigned to the selected sites:": "コピーされた設定は、選択されたサイトに割り当てられます。",
  "Copy": "Copy",
  "Copy and paste this code just before the closing body tag {bodyTag} in all the funnel pages and any extra page where you want to use THN. If you have any doubt don't hesitate on contacting us.": "このコードを、すべてのファネルページおよびTHNを使用したいその他のページで、`</body>`タグの直前にコピー＆ペーストしてください。ご不明な点がございましたら、お気軽にお問い合わせください。",
  "Copy settings to other corporate sites": "設定を他の企業サイトにコピーする",
  "Copy settings to other properties": "設定を他のプロパティにコピーする",
  "Copy settings to other properties:": "設定を他のプロパティにコピーする:",
  "Copy settings to other sites:": "設定を他のサイトにコピーする:",
  "Corporate landing picture": "企業のランディング画像",
  "Corporate logo": "企業ロゴ",
  "Corporate picture": "企業写真",
  "Corporate Sites": "企業サイト",
  "corporate sites": "企業サイト",
  "Create a Login item for your THN account. Click the three dots to the top right and choose “Scan QR code”. Find a {link}.": "THNアカウントのログイン項目を作成します。右上にある三点リーダーをクリックし、「QRコードをスキャン」を選択します。{リンク}を見つけてください。",
  "Create brand": "ブランドを作成する",
  "Create cluster": "クラスターを作成する",
  "Create Login item and scan QR code": "ログインアイテムを作成し、QRコードをスキャンする",
  "Create new brand": "新しいブランドを作成する",
  "Create new cluster": "新しいクラスターを作成する",
  "Create new corporate site": "新しい企業サイトを作成する",
  "Create notification": "通知を作成する",
  "Create site": "サイトを作成する",
  "Create your account": "サインアップ",
  "Create your first Corporate Site": "最初のコーポレートサイトを作成する",
  "Currency and date format preferences when there’s not a property selected. This applies to Overview and brand page reports.": "プロパティが選択されていない場合の通貨および日付の書式設定の好み。これは概要およびブランドページのレポートに適用されます。",
  "Currency format": "通貨形式",
  "Currency in which you will see all the data for this corporate site.": "この企業サイトのすべてのデータが表示される通貨。",
  "Currency in which you will see all the data for this property.": "この物件のすべてのデータが表示される通貨。",
  "Current password": "現在のパスワード",
  "Daily": "毎日の",
  "Daily:": "毎日",
  "Dashboard": "ダッシュボード",
  "Data about a particular {propertyType} or a particular user is never shared. The data is used to create competitive sets (groups of hotels that you can measure your performance against) and compare metrics between your hotels and their compsets. All data shown in BenchDirect is aggregate data.": "特定の{propertyType}または特定のユーザーに関するデータは決して共有されません。このデータは、競合セット（パフォーマンスを測定できるホテルのグループ）を作成し、あなたのホテルとそれらの競合セット間の指標を比較するために使用されます。BenchDirectに表示されるすべてのデータは集計データです。",
  "Data updating": "データ更新",
  "Dates format": "日付形式",
  "Deactivated": "無効化された",
  "Default currency": "デフォルト通貨",
  "Delete": "削除",
  "Delete brand": "ブランドを削除する",
  "Delete cluster": "クラスターを削除する",
  "Delete notification": "通知を削除する",
  "Delete page": "ページを削除する",
  "Delete photo": "写真を削除する",
  "Deleting the page will remove any active messages from it. Those messages will be active on any other pages they're assigned to.": "ページを削除すると、そこにあるアクティブなメッセージはすべて削除されます。それらのメッセージは、割り当てられている他のページではアクティブなままになります。",
  "Demand": "需要",
  "demand_product_description": "有料キャンペーンを通じてウェブサイトに質の高いトラフィックを誘導する",
  "Didn't receive the email? {btn}": "メールは届きませんでしたか？{btn}",
  "Disparities": "格差",
  "Do you already have an account? {btn}": "すでにホテルネットワークの一員ですか？{btn}",
  "Do you want to compare your performance to the market and competition? Access our hotel benchmarking analytics platform.": "市場や競合他社と比較してパフォーマンスを測定したいですか？当ホテルのベンチマーキング分析プラットフォームにアクセスしてください。",
  "Do you want to delete this notification?": "この通知を削除しますか？",
  "Do you want to delete this page?": "このページを削除しますか？",
  "Do you want to get more direct bookings? Use personalization tools to tailor messages and offers according to each individual's behaviour.": "より直接的な予約を獲得したいですか？個々の行動に合わせてメッセージやオファーを調整するために、パーソナライゼーションツールを使用してください。",
  "Don't remind me again": "もう思い出させないで",
  "Don’t have an account? {btn}": "アカウントをお持ちでない方？{btn}",
  "Download property list.": "プロパティリストをダウンロードする。",
  "Download template": "テンプレートをダウンロード",
  "Drive qualified traffic to your hotel's website and effortlessly boost conversions thanks to our cutting-edge demand platform and fully-managed marketing services. Request a demo.": "当社の最先端の需要プラットフォームと完全管理型のマーケティングサービスにより、ホテルウェブサイトへの質の高いトラフィックを誘導し、コンバージョンを簡単に向上させます。デモをリクエストしてください。",
  "Drop files here": "ファイルをここにドロップしてください",
  "Drop icon": "ドロップアイコン",
  "Each property can only use one mapping rule type per page, and they're already set to a different rule. Remove their existing rule first and import again.": "各プロパティはページごとに1つのマッピングルールタイプのみを使用でき、すでに異なるルールに設定されています。既存のルールを削除してから再度インポートしてください。",
  "Edit": "編集",
  "Edit account role": "アカウントの役割を編集する",
  "Edit brand": "ブランドを編集する",
  "Edit cluster": "クラスターを編集する",
  "Edit notification": "編集通知",
  "Edit Property": "プロパティを編集する",
  "Edit role": "役割を編集する",
  "Edit site": "サイトを編集する",
  "Edit user": "ユーザーを編集",
  "Editing properties": "編集プロパティ",
  "Editing sites": "編集サイト",
  "Editing successful!": "編集が成功しました！",
  "Editing unsuccessful!": "編集できませんでした！",
  "Email": "電子メール",
  "Email communications from THN": "THNからのEメール連絡",
  "Email notifications": "Eメール通知",
  "Empty": "空",
  "English": "英語",
  "english": "英語",
  "English selected by default": "デフォルトで選択されています",
  "Enter a 6-digit code": "6桁のコードを入力してください",
  "Enter a description for the site": "サイトの説明を入力してください",
  "Enter a password": "パスワードを入力してください",
  "Enter a password with at least 8 characters": "8文字以上のパスワードを入力してください",
  "Enter the code from 1Password to verify your identity.": "1Passwordからコードを入力して本人確認を行ってください。",
  "Enter the email address related to this account and we'll send you the instructions to reset your password.": "このアカウントに関連付けられているメールアドレスを入力してください。パスワードをリセットするための手順をお送りします。",
  "Enter your account name": "アカウント名を入力してください",
  "Enter your code": "コードを入力してください",
  "Enter your current password": "現在のパスワードを入力してください",
  "Enter your email": "メールアドレスを入力してください",
  "Enter your last name": "姓を入力してください",
  "Enter your name": "あなたの名前を入力してください",
  "Enter your password": "パスワードを入力してください",
  "Experience the power of next-gen AI across our products": "当社の製品で次世代AIの力を体験してください",
  "Family": "家族旅行",
  "First name": "名",
  "follow these instructions": "これらの指示に従ってください",
  "Forgot your password?": "パスワードを忘れましたか？",
  "Forgot your password? {btn}": "パスワードを忘れましたか？{btn}",
  "Frequency": "周波数",
  "Full access to all products as well as edit and manage all properties, invite users and assign roles": "すべての製品へのフルアクセス、すべてのプロパティの編集と管理、ユーザーの招待とロールの割り当て",
  "General preferences": "一般設定",
  "Get a digest in your inbox and keep track of your disparities.": "受信トレイで概要を取得し、OTAとメタサーチャーの相違点を追跡してください。",
  "Get more info": "もっと情報を得る",
  "Get the summary of the percentage change in each of the metrics: conversion, bookings, rates (BAR) and disparities.": "各指標（コンバージョン、予約数、レート（BAR）、乖離）のパーセンテージ変化の要約を取得してください。",
  "Get your summary report directly in your inbox!": "要約レポートを直接受信トレイで受け取ってください！",
  "Go back": "戻る",
  "Go to Help Center": "ヘルプセンターへ行く",
  "Golf": "ゴルフ",
  "Google Analytics": "Google Analytics",
  "Group your properties by brand!": "プロパティをブランドごとにグループ化してください！",
  "Having trouble with your data?": "データに問題がありますか？",
  "help center": "ヘルプセンター",
  "Here you have a summary of some of the most common errors. Check it out!": "ここに最も一般的なエラーの要約があります。見てください！",
  "Hostel": "ホステル",
  "Hotel address": "ホテルの住所",
  "Hotel information": "ホテル情報",
  "Hotel landing picture": "ホテルのランディング画像",
  "Hotel logo": "ホテルのロゴ",
  "Hotel profile": "ホテルプロフィール",
  "Hotel Profile": "ホテルプロフィール",
  "Hotel type": "ホテルの種類",
  "How is the data used and processed?": "データはどのように使用され、処理されますか？",
  "I agree to the terms and conditions of the {privacyPolicyLink}": "私は{privacyPolicyLink}の利用規約に同意します",
  "I have already scanned it": "私はすでにそれをスキャンしました",
  "If enabled, every time widgets are shown an event will be created in Google Analytics.": "有効になっている場合、ウィジェットが表示されるたびにGoogleアナリティクスにイベントが作成されます。",
  "If the email matches the one we have on your account, you will receive an email with the password recovery instructions shortly. Please make sure to refresh your inbox.": "メールアドレスがアカウントに登録されているものと一致する場合、間もなくパスワード回復の手順が記載されたメールが届きます。受信トレイを更新するようにしてください。",
  "If you are using Google Tag Manager (GTM), please {link} once you activate this setting.": "Google Tag Manager (GTM) を使用している場合は、この設定を有効にした後、{link} をクリックしてください。",
  "If you remove this property, the brand will be empty and automatically deleted.": "このプロパティを削除すると、ブランドは空になり自動的に削除されます。",
  "If you remove this property, the cluster will be empty and automatically deleted.": "このプロパティを削除すると、クラスターは空になり自動的に削除されます。",
  "Import": "インポート",
  "Import URLs in bulk": "URLをまとめてインポートする",
  "Incorrect email or password. Please try again or {link}.": "メールアドレスまたはパスワードが正しくありません。もう一度お試しいただくか、{リンク}をご覧ください。",
  "Info": "情報",
  "Install and login to the 1Password extension.": "1Password拡張機能をインストールしてログインしてください。",
  "Install the 1Password browser extension": "1Passwordブラウザ拡張機能をインストールしてください",
  "Install the THN Script on your website": "ウェブサイトにTHNスクリプトをインストールしてください",
  "Integration": "統合",
  "Integration setup": "統合設定",
  "Invalid CSV format.": "無効なCSV形式です。",
  "Invalid or expired code, try again.": "無効または期限切れのコードです。もう一度お試しください。",
  "Invitation couldn't be sent": "招待状を送信できませんでした",
  "Invitation successfully sent.": "招待状は正常に送信されました。",
  "Invite link expired": "招待リンクの有効期限が切れました",
  "Invite new user(s)": "新しいユーザーを招待する",
  "Invite users": "ユーザーを招待する",
  "It looks like this invite link has expired. Please check with your account owner or your Client Success Specialist if you need help.": "この招待リンクは期限切れのようです。お困りの場合は、アカウントの所有者またはクライアントサクセスペシャリストにご確認ください。",
  "It looks like this link has already been used or has expired.": "このリンクはすでに使用済みか、期限切れのようです。",
  "JavaScript condition is": "JavaScriptの条件は",
  "Language": "言語",
  "Language direction": "言語の方向性",
  "Languages in which your website is available. When you create notes or other texts, you will see a box to enter the translations for each of these languages.": "ウェブサイトが利用可能な言語。メモやその他のテキストを作成する際、これらの各言語の翻訳を入力するためのボックスが表示されます。",
  "Last name": "姓",
  "Left to right": "左から右へ",
  "Leisure": "レジャー",
  "Loading ...": "読み込み中...",
  "Log out": "ログアウト",
  "Login": "ログイン",
  "Logo": "ロゴ",
  "Looks like you are the only one in the account": "あなただけがアカウントにいるようです",
  "Luxury": "豪華",
  "Manage languages": "言語管理",
  "Manage Preferences": "設定を管理する",
  "Manage the access to properties for this user.": "このユーザーのプロパティへのアクセスを管理してください。",
  "Mapped for": "～のためにマッピングされた",
  "Mapping Rules": "マッピングルール",
  "Mapping Values": "値のマッピング",
  "Meet Ernest": "アーネストに会ってください",
  "Monthly": "月次の",
  "Monthly:": "月次",
  "More information here": "詳細はこちら",
  "Motel": "モーテル",
  "Must accept terms and conditions": "利用規約に同意する必要があります",
  "Must have at least 1 lowercase, 1 uppercase, 1 numeric character and length must be between 8 and 20.": "少なくとも1つの小文字、1つの大文字、1つの数字を含み、長さが8から20の間であること。",
  "Name": "名称",
  "New password": "新しいパスワード",
  "Next": "次のページ",
  "No account available with the name: {name}": "名前: {name} のアカウントはありません",
  "No brand created yet": "まだブランドは作成されていません",
  "No data found": "データが見つかりません",
  "No matches found for your search": "検索結果が見つかりませんでした",
  "Nº of rooms": "部屋の数",
  "No properties": "プロパティなし",
  "No properties available.": "利用可能なプロパティはありません。",
  "No properties found in this account": "このアカウントにはプロパティが見つかりません",
  "No valid rows found.": "有効な行が見つかりませんでした。",
  "None": "なし",
  "Not now": "今はいいです",
  "Notification created.": "通知が作成されました。",
  "Notification icon": "通知アイコン",
  "Notification was deleted.": "通知は削除されました。",
  "Notification was saved.": "通知が保存されました。",
  "Notifications": "お知らせ",
  "Now selected:": "選択済み",
  "Now you can access to our products and boost your hotel direct bookings.": "これで当社の製品にアクセスし、ホテルのダイレクト予約を促進できます。",
  "of": "の",
  "Ok": "宜しい",
  "Once deleted, it can't be restored.": "一度削除すると、復元できません。",
  "Only images are allowed": "画像のみが許可されています",
  "Oops! You don't have access to any account": "おっと！アカウントにアクセスできません",
  "Oops! You don't have access to any property or product. Please contact the person responsible for THN within your team.": "おっと！どのプロパティや製品にもアクセスできません。チーム内のTHN担当者に連絡してください。",
  "Operator": "オペレーター",
  "Ops, something went wrong. Please try again later.": "おっと、何かがうまくいきませんでした。後でもう一度お試しください。",
  "optional": "オプション",
  "or": "または",
  "Overview preferences": "概要設定",
  "Owner": "オーナー",
  "Ownership couldn't be transferred.": "所有権を移転できませんでした。",
  "Ownership successfully transferred.": "所有権が正常に移管されました。",
  "Page deleted successfully": "ページは正常に削除されました",
  "Page ID": "ページID",
  "Page name": "ページ名",
  "Page saved successfully": "ページは正常に保存されました",
  "Pages": "ページ数",
  "Pages created rely on the THN Script being installed to collect data and display your messages on the corresponding pages of your site.": "作成されたページは、データを収集し、サイトの対応するページにメッセージを表示するためにTHNスクリプトがインストールされていることに依存します。",
  "Password": "パスワード",
  "Password reset sent": "パスワードリセットを送信しました",
  "Passwords do not match": "パスワードが一致しません",
  "Pending confirmation": "確認待ち",
  "Personal information": "個人情報",
  "Personalization": "パーソナル化",
  "Personalize the user experience to boost conversion rates": "コンバージョン率を向上させるためにユーザー体験をパーソナライズする",
  "Personalize your hotel website's full funnel": "ホテルウェブサイトのフルファネルをパーソナライズする",
  "Please, complete the following information:": "以下の情報を補完してください。",
  "Please, contact {btn}": "{btn}に連絡してください",
  "Please, contact the person responsible for THN within your team.": "チーム内のTHN担当者に連絡してください。",
  "Please, introduce your current password and then set a new one": "現在のパスワードを入力し、その後新しいパスワードを設定してください",
  "Please, retry to edit these properties.": "これらのプロパティを編集し直してください。",
  "Please, retry to edit these sites.": "これらのサイトを編集し直してください。",
  "Please, select the account in which you want to log in:": "ログインしたいアカウントを選択してください:",
  "Please, select the brand to allocate this property:": "この物件を割り当てるブランドを選択してください。",
  "Please, select the cluster to allocate this property:": "このプロパティを割り当てるクラスターを選択してください。",
  "Please, try again": "もう一度試してください",
  "Preferences": "好み",
  "Priority": "優先順位",
  "Privacy Policy": "個人情報保護方針",
  "Profile": "プロフィール",
  "Properties": "プロパティ",
  "properties": "プロパティ",
  "Properties included": "含まれるプロパティ",
  "Properties selected": "選択されたプロパティ",
  "Property": "プロパティ",
  "Property access": "プロパティアクセス",
  "Property name": "物件名",
  "Property's script": "コーポレートサイトのスクリプト",
  "QR code for two-factor authentication setup": "二要素認証設定用のQRコード",
  "Ready to take your hotel's direct booking strategy to new heights?": "ホテルのダイレクトブッキング戦略を新たな高みへと導く準備はできていますか？",
  "Recipients": "受信者",
  "RegExp contains": "RegExp は含む",
  "Remind to this user to accept the invitation you sent to join the account.": "このユーザーに、アカウントに参加するための招待を受け入れるようリマインドしてください。",
  "Remove access": "アクセスを削除する",
  "Remove from brand": "ブランドから削除する",
  "Remove from cluster": "クラスターから削除する",
  "Remove properties and delete brand": "プロパティを削除し、ブランドを削除する",
  "Remove properties and delete cluster": "プロパティを削除し、クラスターを削除する",
  "Remove property": "プロパティを削除する",
  "Remove user": "ユーザーを削除する",
  "Removed access to {0} properties": "{0}プロパティへのアクセスを削除しました",
  "Removing {0} of {1}": "{0}を{1}から削除する",
  "Repeat password": "パスワードを繰り返す",
  "Reset password link expired": "パスワードリセットリンクの有効期限が切れました",
  "Reset your password": "パスワードをリセットする",
  "Resort": "リゾート",
  "Restricted property": "制限されたプロパティ",
  "Return to login": "ログインに戻る",
  "Right to left": "右から左へ",
  "Role": "役割",
  "Rooms and Rates, Booking Confirmed, User Register Page": "客室と料金、予約確定、ユーザー登録ページ",
  "Save changes": "変更を保存する",
  "Save new page": "新しいページを保存",
  "Save selection": "選択を保存",
  "Search": "検索",
  "Search ...": "検索...",
  "Search account": "アカウント検索",
  "Search brand...": "ブランドを検索...",
  "Search cluster...": "検索クラスター...",
  "Search properties ...": "物件を検索...",
  "Search users...": "ユーザーを検索...",
  "Search...": "検索...",
  "Seems like there aren’t any brands created yet": "まだブランドが作成されていないようです",
  "Seems like there aren’t any clusters created yet": "まだクラスターが作成されていないようです",
  "Select a product": "製品を選択してください",
  "Select only languages that are available in your hotel website": "ホテルウェブサイトで利用可能な言語のみを選択してください",
  "Select properties": "プロパティを選択",
  "Select property": "プロパティを選択",
  "Select role for the user(s):": "ユーザーの役割を選択してください:",
  "Select sites": "サイトを選択",
  "Select the properties that you want to add to this brand:": "このブランドに追加したいプロパティを選択してください。",
  "Select the properties you want the notifications from:": "通知を受け取りたいプロパティを選択してください:",
  "Select the properties you want to add to this brand:": "このブランドに追加したいプロパティを選択してください:",
  "Select the properties you want to add to this cluster:": "このクラスターに追加したいプロパティを選択してください:",
  "Select the properties you want to assign to this user(s):": "このユーザーに割り当てたいプロパティを選択してください:",
  "Select the type of notification:": "通知の種類を選択してください",
  "Select the user(s) you want to share this property with:": "このプロパティを共有したいユーザーを選択してください:",
  "Select the user(s) you want to share this site with:": "このサイトを共有したいユーザーを選択してください:",
  "selected": "選択された",
  "Send a new one": "新しいのを送ってください",
  "Send a reminder": "リマインダーを送る",
  "Send invite(s)": "招待状を送る",
  "Send periodic reports to anyone you wish": "希望する誰にでも定期レポートを送信する",
  "Send reminder": "リマインダーを送る",
  "Send reset instructions": "リセット手順を送ってください",
  "Set a new one here": "ここに新しいものを設定してください",
  "Set new password": "新しいパスワードを設定する",
  "Set up 1Password 2FA": "1Passwordの2FAを設定する",
  "Set up your customized reports, select the frequency your prefer, the properties to look at and share it with as many people as you want.": "カスタムレポートを設定し、希望の頻度、確認したいプロパティを選択し、好きなだけ多くの人と共有してください。",
  "Set your new password": "新しいパスワードを設定してください",
  "Settings": "設定",
  "Share": "共有する",
  "Share property": "物件を共有する",
  "Share site": "共有サイト",
  "Show all": "すべて表示",
  "Sign in": "サインイン",
  "Sign in here": "こちらでサインインしてください",
  "Sign up to join": "参加登録する",
  "Single Apartment": "ワンルームマンション",
  "Site information": "サイト情報",
  "Site logo": "サイトロゴ",
  "Sites selected": "選択されたサイト",
  "Ski Resort": "スキーリゾート",
  "Something went wrong. Please try again or contact support via chat if the issue persists.": "何かがうまくいきませんでした。もう一度お試しいただくか、問題が解決しない場合はチャットでサポートにご連絡ください。",
  "Specific properties": "特定の特性",
  "Specific properties from this account.": "このアカウントからの特定のプロパティ。",
  "Start grouping your properties however you like!": "プロパティのグループ化は好きなように始めてください！",
  "Start inviting users to your team.": "チームへのユーザーの招待を開始してください。",
  "step by step guide here": "ステップバイステップガイドはこちら",
  "Take a tour": "ツアーに参加する",
  "Team": "チーム",
  "The account does not exist": "そのアカウントは存在しません",
  "The AI teammate that delivers intelligence, recommends your next move, and helps you act.": "インテリジェンスを提供し、次の行動を推奨し、行動を支援するAIチームメイト。",
  "The chatbot cannot be initialised": "チャットボットを初期化できません",
  "The field length must be between 1 and 60 characters long.": "フィールドの長さは1文字から60文字の間である必要があります。",
  "The properties included will immediately become available to regroup in new brands.": "含まれるプロパティは、新しいブランドで再編成されるとすぐに利用可能になります。",
  "The user already belongs to this account": "ユーザーはこのアカウントにすでに所属しています",
  "The user has been locked out due to too many failed authentication attempts. Please {link} to continue.": "認証試行が多すぎたため、アカウントがロックされています。続行するには{link}をクリックしてください。",
  "The user will no longer have access to the properties.": "ユーザーはプロパティへのアクセスを失います。",
  "There was an error deleting the page": "ページを削除する際にエラーが発生しました",
  "There was an error loading the page": "ページを読み込む際にエラーが発生しました",
  "There was an error saving the page": "ページを保存する際にエラーが発生しました",
  "These pages are managed automatically": "これらのページは自動的に管理されています",
  "This action cannot be undone.": "この操作は元に戻せません。",
  "This field is required": "このフィールドは必須です。",
  "This field must be a valid email": "このフィールドは有効なメールアドレスである必要があります",
  "This field must be a valid URL, e.g. https://hotel.com": "このフィールドは有効なURLである必要があります。例：https://hotel.com",
  "This field must be at least {min} characters": "このフィールドは少なくとも{min}文字である必要があります",
  "This image will be used for reports, notifications and other account communications.": "この画像は、レポート、通知、その他のアカウントコミュニケーションに使用されます。",
  "This is your THN tracking code for {propertyName}. This script allows us to track and follow the complete booking funnel throughout your website and analyze the right metrics of your direct booking performance, as well as display all the widgets and messages you configure.": "これは{propertyName}のTHNトラッキングコードです。このスクリプトにより、お客様のウェブサイト全体での予約ファネルを追跡し、直接予約パフォーマンスの適切な指標を分析するとともに、設定されたすべてのウィジェットやメッセージを表示できます。",
  "This user already has access to all properties, you cant add more.": "このユーザーはすでにすべてのプロパティにアクセスしているため、追加することはできません。",
  "This user will no longer be able to access to this/these property(ies).": "このユーザーは、この/これらのプロパティにアクセスできなくなります。",
  "Timeshare": "タイムシェア",
  "Timezone": "タイムゾーン",
  "Title": "タイトル",
  "Transfer ownership": "所有権を移転する",
  "Transfer properties and delete brand": "プロパティを転送し、ブランドを削除する",
  "Transfer properties and delete cluster": "プロパティを転送し、クラスターを削除する",
  "Transfer property": "所有権の移転",
  "Transfer this property to another brand": "このプロパティを別のブランドに移管してください",
  "Transfer this property to another cluster": "このプロパティを別のクラスターに転送してください",
  "Transfer to another brand": "別のブランドに移行する",
  "Transfer to another cluster": "別のクラスターに移動する",
  "Untitled page": "無題のページ",
  "URL": "URL",
  "URL contains": "URLは含む",
  "URL equals": "URLは",
  "Use clusters to visualize and filter your properties categorizing them by similar variables: location, hotel type, number of stars and even by number of rooms.": "クラスターを使用して、場所、ホテルタイプ、星の数、部屋の数といった類似した変数でプロパティを分類し、可視化およびフィルタリングします。",
  "User": "ユーザー",
  "User invited": "ユーザーを招待しました",
  "User removed": "ユーザー削除",
  "User role was successfully changed.": "ユーザーロールは正常に変更されました。",
  "User was successfully removed.": "ユーザーは正常に削除されました。",
  "Users": "ユーザー",
  "Users invited": "ユーザーを招待",
  "Validating emails ...": "メールを検証中...",
  "Verify": "検証する",
  "View brand": "ブランドを見る",
  "View cluster": "クラスターを表示",
  "View info": "情報を見る",
  "View Property": "物件を見る",
  "View site": "サイトを見る",
  "Visualize and analyze your brand data classifying those properties within the same brand into one group.": "ブランドデータを可視化し、同じブランド内のプロパティを一つのグループに分類して分析する。",
  "We respect your privacy, therefore we will not share your personal information with third parties or partners.": "お客様のプライバシーを尊重しており、個人情報を第三者やパートナーと共有することはありません。",
  "Weekly": "毎週",
  "Weekly:": "毎週",
  "Welcome": "ようこそ",
  "Welcome {0},": "ようこそ、{0}",
  "Welcome to THN": "THNへようこそ",
  "Wellness & Spa": "ウェルネス＆スパ",
  "Widget data": "ウィジェットデータ",
  "Without it, messages won’t be shown and no data will be collected.": "それがないと、メッセージは表示されず、データも収集されません。",
  "Write the number of rooms": "部屋の数",
  "Yes, remove access": "はい、アクセスを削除してください",
  "Yes, remove user": "はい、ユーザーを削除します",
  "You are about to delete this brand": "このブランドを削除しようとしています",
  "You are about to delete this cluster": "このクラスターを削除しようとしています",
  "You are about to transfer the ownership to this user. Your role will change to Operator, and you will no longer be able to edit the account information.": "このユーザーに所有権を移転しようとしています。あなたの役割はオペレーターに変わり、アカウント情報を編集できなくなります。",
  "You can add it again later.": "後でまた追加できます。",
  "You can’t invite users that are already in the account": "アカウントにすでにいるユーザーを招待することはできません",
  "You haven't created any email notification yet": "まだメール通知を作成していません",
  "You will see brands here when an admin user creates them.": "管理ユーザーがそれらを作成したときに、ここにブランドが表示されます。",
  "You will see clusters here when an admin creates them.": "管理者が作成した際に、ここにクラスターが表示されます。",
  "Your brand was successfully removed.": "あなたのブランドは正常に削除されました。",
  "Your Brand was successfully updated.": "あなたのブランドは正常に更新されました。",
  "Your cluster was successfully removed.": "クラスタは正常に削除されました。",
  "Your Cluster was successfully updated.": "クラスターは正常に更新されました。",
  "Your new password has been successfully set": "新しいパスワードは正常に設定されました",
  "Your password was successfully changed.": "パスワードは正常に変更されました。",
  "Your profile was successfully updated.": "プロフィールは正常に更新されました。",
  "Your Properties was successfully removed from brand.": "あなたのプロパティはブランドから正常に削除されました。",
  "Your Properties was successfully removed from cluster.": "あなたのプロパティはクラスターから正常に削除されました。",
  "Your properties was successfully transferred.": "あなたのプロパティは正常に転送されました。",
  "Your property was successfully updated.": "プロパティは正常に更新されました。",
  "Your site was created.": "あなたのサイトが作成されました。",
  "Your site was successfully updated.": "サイトは正常に更新されました。",
  "Your verification session expired. Please sign in again.": "認証セッションが切れました。再度サインインしてください。"
}